import { render, staticRenderFns } from "./ConsultaNutricional.vue?vue&type=template&id=0767f618"
import script from "./ConsultaNutricional.vue?vue&type=script&lang=js"
export * from "./ConsultaNutricional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports